const contactList = state => state.contactList;

const contactListLoading = state => state.contactListLoading;

const messages = state => state.messages.allMessages;

const messagesLoading = state => state.messagesLoading;

const connect = state => state.connect;

const connectLoading = state => state.connectLoading;

const blockedUser = state => state.blockedUser;

const unblockedUser = state => state.unblockedUser;

const blockedUserLoading = state => state.blockedUserLoading;

const unblockedUserLoading = state => state.unblockedUserLoading;

const savedUser = state => state.savedUser;

const savedUserLoading = state => state.savedUserLoading;

const searchedMessages = state => state.searchedMessages;

const searchedMessagesLoading = state => state.searchedMessagesLoading;

const currentPage = state => state.currentPage;

const messagePageLoading = state => state.messagePageLoading;

const currentPageMessages = state => state.messages.current;

const pageHistory = state => state.pageHistory;

const senderProfile = state => state.senderProfile;

const senderProfileLoading = state => state.senderProfileLoading;

const contactListPage = state => state.contactListPage;

const currentContacts = state => state.contacts.current;

const contacts = state => state.contacts.allContacts;

const unreadChatCount = state => state.contacts.unreadCount;

const receiverProfile = state => state.receiverProfile;

export default {
  contactList,
  contactListLoading,
  messages,
  messagesLoading,
  connect,
  connectLoading,
  blockedUser,
  blockedUserLoading,
  unblockedUser,
  unblockedUserLoading,
  searchedMessages,
  searchedMessagesLoading,
  currentPage,
  messagePageLoading,
  currentPageMessages,
  pageHistory,
  senderProfile,
  senderProfileLoading,
  contactListPage,
  currentContacts,
  contacts,
  unreadChatCount,
  savedUser,
  savedUserLoading,
  receiverProfile
};
